//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ProfileAvatar from "@Shared/components/general/profile-avatar";
import BackButton from "@Shared/components/general/back-button";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import { isEmpty } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "AgentDetailsHeader",
  components: {
    ProfileAvatar,
    BackButton,
    SimpleButton
  },
  props: {
    agent: {
      type: Object,
      default: () => ({})
    },
    loading: {
      type: Boolean,
      default: false
    },
    canSave: {
      type: Boolean,
      default: false
    },
    saving: {
      type: Boolean,
      default: false
    },
    savingSucceeded: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    fullname() {
      return isEmpty(this.agent) ? "" : `${this.agent.givenName} ${this.agent.familyName}`;
    }
  },
  methods: {
    handleSubmit() {
      this.$emit("submit");
    }
  }
});